var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));

var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));

var useSizeStyleProp_1 = require("../../hooks/useSizeStyleProp");

exports.useStyles = makeStyles_1.default(function (theme) {
  return createStyles_1.default({
    root: function root(_a) {
      var disableSelection = _a.disableSelection,
          height = _a.height,
          maxHeight = _a.maxHeight,
          maxWidth = _a.maxWidth,
          width = _a.width;
      return {
        height: useSizeStyleProp_1.getSizeStyleProp({
          theme: theme,
          value: height
        }),
        maxHeight: useSizeStyleProp_1.getSizeStyleProp({
          theme: theme,
          value: maxHeight
        }),
        maxWidth: useSizeStyleProp_1.getSizeStyleProp({
          theme: theme,
          value: maxWidth
        }),
        userSelect: disableSelection ? "none" : "auto",
        width: useSizeStyleProp_1.getSizeStyleProp({
          theme: theme,
          value: width
        })
      };
    }
  });
}, {
  name: "NatDSImage"
});
exports.default = exports.useStyles;